// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1965436110
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

@Injectable({
  providedIn: 'root',
})
export class TestApiService {
  constructor(protected http: HttpClient) {}

  getServerError(): Observable<number[]> {
    const url = environment.chiliSauceApiRoot + `/api/Test`;
    return this.http.get<number[]>(url);
  }
}
